/* ── MIGRATION GUARD ──────────────────────────────────────────
   cart drawer upgrades — would conflict with Upcart while that app is live.
   Runs ONLY in preview (?br_preview=1) until you switch it on for
   real by adding 'cart' to window.BR_LIVE. ------------------- */
(function(){
  var live = (window.BR_LIVE || []).indexOf('cart') > -1;
  var preview = document.documentElement.classList.contains('br-preview');
  if (!live && !preview) return;   // dormant: the existing app keeps working untouched
/* ============================================================
   Bella Roux CRO — Module 1: Cart drawer upgrades
   - Shipping-protection AJAX toggle (adds/removes a service variant)
   - Drawer upsell (Shopify product recommendations, 1-click add)
   Section Rendering API keeps the native drawer in sync, no reload.
   Event-delegated => survives re-renders.
   ============================================================ */
(function () {
  var DRAWER = 'cart-drawer', BUBBLE = 'cart-icon-bubble';

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json(); });
  }
  // Canonical way to get a sectioned cart snapshot after any mutation
  function sectionedCart() {
    return json('/cart/update.js', { sections: DRAWER + ',' + BUBBLE, sections_url: window.location.pathname });
  }

  /* --------------------------------------------------------------------
     SHARED CART CACHE.

     MEASURED (2026-09-09): a single click on Add to Cart fired at least
     four separate fetches of /cart.js from four different functions in
     this file (manageGift, spQuantity via enforceProtection twice), on
     top of the add.js call itself and the sectioned re-render -- staggered
     up to 3 seconds after the click. Each function was independently
     correct; the problem was that none of them knew the others already
     had the answer.

     Every mutation in this file already ends with a full cart object in
     hand -- either the plain JSON /cart/add.js or /cart/update.js
     returns, or one can be read for free out of the sectioned response.
     Writing that object here once, and having every consumer read it
     instead of asking the server again, turns "N read-your-own-write round
     trips" into "0" for anything that runs after a mutation this file
     itself made. The one real gap -- first load, before this file has
     ever seen a cart -- still does exactly one fetch, same as before.
  -------------------------------------------------------------------- */
  var cartCache = null;               // last known real /cart.js-shaped object
  var cartCachePromise = null;        // in-flight de-dupe for the cold-start read

  function setCartCache(cart) {
    if (cart && cart.items) cartCache = cart;
    return cart;
  }

  /** Resolve to a cart object without a network call whenever possible. */
  function getCart() {
    if (cartCache) return Promise.resolve(cartCache);
    if (cartCachePromise) return cartCachePromise;
    cartCachePromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCachePromise = null; return setCartCache(c); })
      .catch(function (e) { cartCachePromise = null; throw e; });
    return cartCachePromise;
  }

  function refresh(res, knownState) {
    if (!res || !res.sections) return;
    var parser = new DOMParser();
    if (res.sections[DRAWER]) {
      var doc = parser.parseFromString(res.sections[DRAWER], 'text/html');
      var fresh = doc.querySelector('cart-drawer'), live = document.querySelector('cart-drawer');
      if (fresh && live) {
        var open = live.classList.contains('active') || live.classList.contains('animate');
        live.innerHTML = fresh.innerHTML;
        live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        if (open) live.classList.add('active', 'animate');
        fillUpsell();
        // MEASURED: the real bug was an ORDERING race, not a missing sync.
        // manageProtection() used to run right here, unconditionally. It
        // debounces to an async fetch('/cart.js') 80ms later and calls
        // syncToggle() itself -- so with a knownState in hand, TWO async
        // writers ended up touching the same checkbox node, and whichever
        // settled last won. That is exactly the measured symptom: correct
        // at ~100ms, wrong again at ~1.8s (manageProtection's own chain
        // resolving and re-painting), only correcting a second time once
        // ITS OWN redundant read finally agreed with the cart.
        //
        // Fix: when the caller already knows the answer, apply it here,
        // synchronously, and skip manageProtection() entirely for this
        // redraw -- there is nothing left for it to reconcile. It still runs
        // on every other path (plain cart adds, page load) where no
        // knownState is available.
        var cbAfterRedraw = document.querySelector(SP_SELECTOR);
        if (cbAfterRedraw && knownState && knownState.variantId) {
          syncToggle(cbAfterRedraw, !!knownState.checked);
        } else {
          manageProtection();
        }
        manageGift();
        startReserve();
        // the drawer was just rebuilt from server HTML, so anything this file
        // painted onto it is gone and has to be reapplied — with the cart we
        // were just given, not a fresh fetch that may lag behind it
        paintCheckoutTotal(); paintLadder();
      }
    }
    if (res.sections[BUBBLE]) {
      var b = document.getElementById('cart-icon-bubble');
      if (b) { var d = parser.parseFromString(res.sections[BUBBLE], 'text/html').getElementById('cart-icon-bubble'); if (d) b.innerHTML = d.innerHTML; }
    }
    document.querySelectorAll('[data-tabbar-count]').forEach(function (el) {
      if (typeof res.item_count === 'number') { el.textContent = res.item_count; el.hidden = res.item_count === 0; }
    });
  }

  // --- Auto free-gift (Rewards Ladder tier 2) ---
  var busyGift = false;
  function manageGift() {
    var ladder = document.querySelector('[data-cro-ladder]'); if (!ladder || busyGift) return;
    var threshold = Number(ladder.getAttribute('data-gift-threshold'));
    var vid = Number(ladder.getAttribute('data-gift-variant'));
    if (!vid || !threshold) return;
    busyGift = true;
    getCart().then(function (cart) {
      // Absolute write, exactly like the shipping-protection sync above.
      // add.js INCREMENTS, so a read-then-add can double the gift whenever a
      // second cart update lands between the read and the write — the same
      // race that put two Shipping Protections on one order. Stating the
      // wanted quantity instead of a delta makes a repeat harmless.
      var have = cart.items.reduce(function (n, i) {
        return n + (i.variant_id === vid ? i.quantity : 0);
      }, 0);
      var want = cart.total_price >= threshold ? 1 : 0;
      if (have === want) return;
      cartCache = null;   // about to write; the cache is about to be stale
      return json('/cart/update.js', { updates: kv(vid, want) })
        .then(function (c) { setCartCache(c); return sectionedCart(); })
        .then(refresh);
    }).catch(function () {}).finally(function () { busyGift = false; });
  }
  // Catch native cart changes (Sense pub/sub) too
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    // The theme drives its own cart updates too. Without hooking those, a
    // product added through the theme's path re-renders the drawer and silently
    // undoes both the protection sync and the button total.
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      // A write this file did NOT make (the theme's own add-to-cart path,
      // e.g. the bundle box) just landed -- the cache is stale by
      // definition. Clearing it means the two calls below share ONE fresh
      // read via getCart()'s in-flight de-dupe, instead of each firing its
      // own /cart.js (that de-dupe is what turns this into a single request
      // no matter how many consumers ask at once).
      cartCache = null;
      setTimeout(function () { manageGift(); manageProtection(); }, 60);
      repaintSoon();
    });
  }

  // --- Shipping protection -------------------------------------------------
  //
  // The theme renders this toggle itself, as
  //     <input type="checkbox" checked data-br-sp-precheck>
  // with NO data-variant attribute. An earlier version of this file looked for
  // [data-cro-shipprot] and read data-variant off it, so it matched nothing and
  // silently did nothing: the box rendered checked while the line item was
  // never added. Toggling off and on worked because that is a different code
  // path. Measured cost of the mismatch: 15.3% attach instead of ~80%, about
  // $1,230/month of pure-margin revenue.
  //
  // Two rules learned from that:
  //   · match BOTH attribute names, since either may be present
  //   · trust the CART, never the checkbox, for whether protection is applied

  var SP_SELECTOR = '[data-br-sp-precheck],[data-cro-shipprot]';

  /** Resolve the variant id at runtime so a product swap cannot break this. */
  function spVariant() {
    var cb = document.querySelector(SP_SELECTOR);
    var attr = cb && Number(cb.getAttribute('data-variant'));
    if (attr) return Promise.resolve(attr);
    try {
      var cached = Number(sessionStorage.getItem('br_sp_variant'));
      if (cached) return Promise.resolve(cached);
    } catch (x) {}
    return fetch('/products/shipping-protection.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var id = p && p.variants && p.variants[0] && p.variants[0].id;
        if (id) { try { sessionStorage.setItem('br_sp_variant', id); } catch (x) {} }
        return id || 0;
      })
      .catch(function () { return 0; });
  }

  /** How many protection units are in the cart. null = couldn't tell. */
  function spQuantity(id) {
    return getCart()
      .then(function (c) {
        var n = 0;
        (c.items || []).forEach(function (i) {
          if (Number(i.id) === Number(id)) n += Number(i.quantity || 0);
        });
        return n;
      })
      .catch(function () { return null; });   // unknown, so we do nothing
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest(SP_SELECTOR); if (!cb) return;
    cb.disabled = true;
    if (!cb.checked) { try { sessionStorage.setItem('br_sp_optout', '1'); } catch (x) {} }
    else { try { sessionStorage.removeItem('br_sp_optout'); } catch (x) {} }
    var want = cb.checked ? 1 : 0;
    spVariant().then(function (id) {
      if (!id) return;
      // same absolute write as the enforcer, so a fast double-click cannot
      // stack two lines
      cartCache = null;
      return json('/cart/update.js', { updates: kv(id, want) })
        .then(function (c) { setCartCache(c); return sectionedCart(); })
        .then(function (res) {
          refresh(res, { variantId: id, checked: want > 0 });
          paintCheckoutTotal(); paintLadder();
        });
    }).catch(function () { cb.checked = !cb.checked; })
      .finally(function () { cb.disabled = false; });
  });

  /**
   * Force protection to EXACTLY the desired quantity.
   *
   * History of this function, because the shape matters:
   *   1. add.js when "not present"  → added one per product (add.js increments)
   *   2. read, then change.js to 1  → still doubled: something adds a second
   *      line AFTER the read, and reconciling after the fact loses that race
   *      every time.
   *
   * /cart/update.js with `updates` SETS the total quantity for a variant across
   * the whole cart in one call. It does not increment, it does not care how many
   * lines exist, and it does not depend on what was there a moment ago. Running
   * it unconditionally is what makes the outcome independent of the race.
   *
   * Debounced so a burst of cart changes settles into a single write, and so it
   * lands after anything else that touches the cart.
   */
  var spTimer = null, busySP = false;

  function manageProtection() {
    clearTimeout(spTimer);
    // 250ms was long enough that the drawer rendered a checked toggle beside a
    // cart that did not contain protection yet — it read as "stuck".
    spTimer = setTimeout(enforceProtection, 80);
  }

  function enforceProtection() {
    var cb = document.querySelector(SP_SELECTOR);
    if (!cb || busySP) return;
    if (cb.getAttribute('data-default') === 'false') return;

    /* MEASURED (2026-09-07): this ran on page load, so a brand-new visitor who
       had touched nothing got Shipping Protection written into their cart
       ~2.5s after landing:
           +2550ms POST /cart/update.js {"updates":{"49459309740332":1}}
       Two costs, both real:

       1. The shopper sees an item they never chose. On a first visit from a
          cold ad that reads as a scam, and it is the single most likely reason
          15 sessions produced 10 "add to carts" and ZERO checkouts.

       2. Shopify's Web Pixel cannot tell an app's cart write from a shopper's
          click, so every page load fired product_added_to_cart. 25 of 28 ATC
          events in the pixel log were Shipping Protection; the actual necklace
          was added ONCE. That fake signal was also being fed to Meta, which
          was therefore optimising toward people who merely load the page.

       Fix: only attach protection to a cart that already holds something the
       shopper chose. An empty cart is left alone. This keeps the offer and the
       ~80% attach rate (anyone with a product in their cart is a real shopper)
       while making both the cart and the analytics honest. */
    var protId = Number(cb.getAttribute('data-variant')) || 0;
    return getCart()
      .then(function (c) {
        var realItems = (c.items || []).filter(function (i) {
          return Number(i.id) !== protId && !/shipping protection/i.test(i.product_title || '');
        });
        if (!realItems.length) return;      /* nothing chosen yet -- stay out */
        return enforceProtectionInner(cb);
      })
      .catch(function () {});
  }

  function enforceProtectionInner(cb) {

    var optedOut = false;
    try { optedOut = sessionStorage.getItem('br_sp_optout') === '1'; } catch (x) {}
    if (optedOut) cb.checked = false;
    var want = cb.checked ? 1 : 0;

    busySP = true;
    spVariant().then(function (id) {
      if (!id) return null;
      return spQuantity(id).then(function (have) {
        if (have === null) return null;                       // couldn't read the cart
        // Keep the switch honest even when no write is needed: a toggle showing
        // ON while the cart has none is the thing that looks broken.
        syncToggle(cb, have > 0);
        if (have === want) return null;
        cartCache = null;
        return json('/cart/update.js', { updates: kv(id, want) })
          .then(function (c) { setCartCache(c); return sectionedCart(); })
          .then(function (res) {
            // Second call site with the same gap the click handler had: id
            // and want are already known here, so hand them to refresh()
            // for a synchronous paint instead of leaving the fresh node
            // wrong until this .then() resolves.
            refresh(res, { variantId: id, checked: want > 0 });
            paintCheckoutTotal(); paintLadder();
          });
      });
    }).catch(function () {}).finally(function () { busySP = false; });
  }

  function kv(id, qty) { var o = {}; o[String(id)] = qty; return o; }

  /** Make the switch show what the cart actually contains. */
  function syncToggle(cb, on) {
    if (!cb) return;
    if (cb.checked !== on) cb.checked = on;
    var label = cb.closest('label');
    if (label) label.classList.toggle('unchecked', !on);
  }

  // --- Checkout button: brand colour + live total ---------------------------
  //
  // The theme ships this button black with no price on it. Both are worth
  // changing: showing the amount on the button removes a moment of "how much
  // am I about to be charged", and the black conflicted with the brand.
  //
  // Styles are injected rather than put in a stylesheet because the same two
  // buttons render in the drawer and on the cart page, and both are theme
  // markup this file already has to reach into.

  var BRAND = '#d5c3cf';
  var CHECKOUT_BTNS = '#CartDrawer-Checkout, #checkout, .cart__checkout-button';

  // MEASURED bug this fixes: the "Checkout Button Background/Text Color"
  // settings in the Cart Drawer section were fully wired on the Liquid side
  // (a section <style> block reading them, both with !important) but this
  // file ALSO injects its own <style> tag at RUNTIME with a hardcoded
  // colour, appended to <head> after the page has already parsed -- so for
  // two equally-specific !important rules, this one always wins on
  // cascade order, and the section settings visibly did nothing no matter
  // what they were set to. Reading the same two settings here (via a small
  // inline script the section renders) instead of the BRAND constant makes
  // this the SAME source of truth as the settings panel, rather than a
  // competing one.
  var CHECKOUT_BG = (window.BR_CART_OPTS && window.BR_CART_OPTS.checkoutBg) || BRAND;
  var CHECKOUT_TEXT = (window.BR_CART_OPTS && window.BR_CART_OPTS.checkoutText) || '#000000';

  function injectCheckoutStyle() {
    if (document.getElementById('br-checkout-style')) return;
    var st = document.createElement('style');
    st.id = 'br-checkout-style';
    st.textContent =
      '#CartDrawer-Checkout,#checkout,.cart__checkout-button{' +
        'background:' + CHECKOUT_BG + ' !important;' +
        'background-image:none !important;' +
        'border-color:' + CHECKOUT_BG + ' !important;' +
        'color:' + CHECKOUT_TEXT + ' !important;' +
      '}' +
      '#CartDrawer-Checkout:hover,#checkout:hover,.cart__checkout-button:hover{' +
        'filter:brightness(.95);' +
      '}' +
      '#CartDrawer-Checkout *,#checkout *,.cart__checkout-button *{color:' + CHECKOUT_TEXT + ' !important;}' +
      // Two columns, not three items on one centred line. The lock and the
      // words are wrapped into a single label so space-between has exactly two
      // children to push apart; without the wrapper the icon, the text and the
      // price each become their own flex item and spread out unevenly.
      '#CartDrawer-Checkout,#checkout,.cart__checkout-button{' +
        'display:flex !important;align-items:center;justify-content:center;' +
        'gap:12px;padding-left:22px !important;padding-right:22px !important;' +
        'text-align:left;line-height:1.2;' +
        // inset the button itself. Padding on the wrapper was being overridden
        // by the theme, so the margin lives here where !important applies.
        'margin-left:var(--br-cta-inset,14px) !important;' +
        'margin-right:var(--br-cta-inset,14px) !important;' +
        'width:calc(100% - (2 * var(--br-cta-inset,14px))) !important;' +
        'box-sizing:border-box !important;' +
      '}' +
      '.br-cta-split{justify-content:space-between !important;}' +
      '.br-cta-label{display:inline-flex;align-items:center;gap:8px;min-width:0;}' +
      // tabular figures keep the price a constant width, so the button does not
      // twitch as the total changes from $9.99 to $110.00
      '.br-cta-compare{font-weight:600;font-variant-numeric:tabular-nums;'+
      'text-decoration:line-through;white-space:nowrap;flex:0 0 auto;'+
      'opacity:var(--br-cta-compare-opacity,.5);margin-right:6px;'+
      'color:var(--br-cta-compare-color,inherit);}' +
      '.br-cta-amount{font-weight:700;font-variant-numeric:tabular-nums;' +
        'white-space:nowrap;flex:0 0 auto;}' +
      // the dash that sits between the live price and the struck "was" price --
      // without it the two numbers read as a typo ("$152 $212"), not a discount.
      '.br-cta-sep{opacity:.55;font-weight:500;flex:0 0 auto;margin:0 5px;}' +
      // The free-item badge renders white on a near-white chip, so the word
      // "Free Gift" is invisible — on the one line most worth reading.
      '.cart-item__discounted-prices .free-gift,' +
      '.free-gift,[class*="free-gift"],[class*="freeGift"],' +
      '.cart-item__discount,.cart-item__discount-badge{' +
        'background:' + BRAND + ' !important;color:#000 !important;' +
        'border:1px solid rgba(0,0,0,.15) !important;font-weight:700 !important;' +
        'padding:.2rem .6rem !important;border-radius:99px !important;' +
      '}' +
      '.cart-item__discounted-prices .free-gift *,[class*="free-gift"] *{color:#000 !important;}';
    document.head.appendChild(st);
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  /**
   * Append the live cart total to both checkout buttons.
   *
   * Appends a <span> rather than rewriting textContent: the button contains a
   * lock icon as inline SVG, and setting textContent silently deletes it.
   */
  /**
   * Mirror the total the drawer is ALREADY showing.
   *
   * Every version of this that asked the server for a number ended up one
   * update behind — the button said $77.98 beside a $42.98 cart, then $7.98
   * beside $42.98. Fetches race the re-render, and there is no ordering that
   * reliably wins.
   *
   * Reading the rendered total removes the race by construction: the button and
   * the cart are literally the same number, so they cannot disagree. If the
   * element isn't there (empty cart, unknown markup), the amount is removed
   * rather than left showing a stale figure.
   */
  var TOTAL_SELECTORS = [
    '.totals__total-value',
    '.gb-totals-total-value',
    '.totals .money',
    '[data-cart-total]'
  ];

  function readRenderedTotal() {
    for (var i = 0; i < TOTAL_SELECTORS.length; i++) {
      var els = document.querySelectorAll(TOTAL_SELECTORS[i]);
      for (var j = els.length - 1; j >= 0; j--) {          // last = drawer footer
        var el = els[j];
        if (el.offsetParent === null && el.style.display === 'none') continue;
        var txt = (el.textContent || '').trim();
        var m = txt.match(/[\d][\d.,]*/);
        if (m) return txt.replace(/\s+/g, ' ');
      }
    }
    return null;
  }

  /* The theme already prints a compare-at total in the drawer's totals row
     (<s class="cart-item__old-price">). Read it from there instead of
     recomputing, so the struck-out figure in the button can never
     disagree with the theme. textContent survives display:none, so this
     keeps working once that row is hidden. */
  function readRenderedCompare() {
    var el = document.querySelector(
      'cart-drawer .totals s.cart-item__old-price, #CartDrawer .totals s.cart-item__old-price, ' +
      'cart-drawer .discount_price-container s, #CartDrawer .discount_price-container s');
    if (!el) return null;
    var txt = (el.textContent || '').trim();
    return /[0-9]/.test(txt) ? txt.replace(/\s+/g, ' ') : null;
  }

  function paintCheckoutTotal() {
    injectCheckoutStyle();
    var label = readRenderedTotal();
    document.querySelectorAll(CHECKOUT_BTNS).forEach(function (btn) {
      // Wrap whatever the theme put in the button (lock icon + wording) into a
      // single label element, once. The theme re-renders the drawer on every
      // cart change, so this has to be idempotent and has to re-run.
      var wrap = btn.querySelector('.br-cta-label');
      if (!wrap) {
        wrap = document.createElement('span');
        wrap.className = 'br-cta-label';
        while (btn.firstChild) {
          var node = btn.firstChild;
          if (node.nodeType === 1 && node.classList &&
              node.classList.contains('br-cta-amount')) {
            btn.removeChild(node);
            continue;
          }
          wrap.appendChild(node);          // appendChild moves it out of btn
        }
        btn.appendChild(wrap);
      }

      var span = btn.querySelector('.br-cta-amount');
      if (!label) {
        // Empty cart: no price to show, so centre the label again rather than
        // leaving it stranded against the left edge.
        if (span) span.remove();
        btn.classList.remove('br-cta-split');
        return;
      }
      if (!span) {
        span = document.createElement('span');
        span.className = 'br-cta-amount';
        btn.appendChild(span);
      }
      if (span.textContent !== label) span.textContent = label;
      /* Live price left, struck-was right -- the same order as the line item
         above it ("GBP 57.00  GBP 74.00"), which used to disagree with this
         button's order ("GBP 120.00  GBP 57.00": struck-was FIRST). One offer
         read two directions in the same drawer. Opt out via the section
         setting, which the drawer publishes on window.BR_CART_OPTS. */
      var brOpts = window.BR_CART_OPTS || {};
      var compare = (brOpts.showCheckoutCompare === false) ? null : readRenderedCompare();
      var sepSpan = btn.querySelector('.br-cta-sep');
      var cmpSpan = btn.querySelector('.br-cta-compare');
      if (compare && compare !== label) {
        if (!sepSpan) {
          sepSpan = document.createElement('span');
          sepSpan.className = 'br-cta-sep';
          sepSpan.setAttribute('aria-hidden', 'true');
          sepSpan.textContent = '–';
          span.parentNode.insertBefore(sepSpan, span.nextSibling);
        }
        if (!cmpSpan) {
          cmpSpan = document.createElement('span');
          cmpSpan.className = 'br-cta-compare';
          sepSpan.parentNode.insertBefore(cmpSpan, sepSpan.nextSibling);
        }
        if (cmpSpan.textContent !== compare) cmpSpan.textContent = compare;
      } else {
        if (cmpSpan) cmpSpan.remove();
        if (sepSpan) sepSpan.remove();
      }

      btn.classList.add('br-cta-split');
    });
  }

  // --- Reservation countdown ("reserved for MM:SS") ---
  /** '#RRGGBB' -> [r,g,b]. Anything unparseable falls back to mid grey. */
  function hex2rgb(h) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(String(h || '').trim());
    return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : [136, 136, 136];
  }
  /** Blend two colours. t=0 is `a`, t=1 is `b`. */
  function mix(a, b, t) {
    var x = hex2rgb(a), y = hex2rgb(b);
    return 'rgb(' + Math.round(x[0] + (y[0] - x[0]) * t) + ','
                  + Math.round(x[1] + (y[1] - x[1]) * t) + ','
                  + Math.round(x[2] + (y[2] - x[2]) * t) + ')';
  }

  function startReserve() {
    var bar = document.querySelector('[data-cro-reserve]'); if (!bar || bar.dataset.running === '1') return;
    bar.dataset.running = '1';
    var mins = parseInt(bar.getAttribute('data-minutes'), 10) || 5;
    var from = bar.getAttribute('data-from') || '#F5DADF';
    var to   = bar.getAttribute('data-to')   || '#E03131';
    var total = mins * 60000;
    var key = 'br_reserve_deadline';
    var deadline;
    try { deadline = parseInt(sessionStorage.getItem(key), 10); } catch (x) {}
    // A frozen 00:00 reads as a broken page. If the window has lapsed, start a
    // fresh one rather than sitting on an expired countdown.
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + total;
      try { sessionStorage.setItem(key, deadline); } catch (x) {}
    }
    (function tick() {
      var live = document.querySelector('[data-cro-reserve-clock]'); if (!live) return;
      var left = deadline - Date.now();
      // Roll over BEFORE painting. Showing 00:00 for a second reads as a dead
      // timer, which is worse than no timer at all.
      if (left <= 0) {
        deadline = Date.now() + total;
        try { sessionStorage.setItem(key, deadline); } catch (x) {}
        left = total;
      }
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      live.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;

      setTimeout(tick, 1000);
    })();

    /* The bar drains on its own animation frame rather than on the 1s clock
       tick. Stepping it once a second is visibly steppy no matter what CSS
       transition is applied, because each step is a fresh 1s ease that gets
       interrupted. requestAnimationFrame gives a continuous 60fps slide and
       lets the colour cross-fade at the same resolution. */
    (function drain() {
      var fill = document.querySelector('[data-cro-reserve-fill]');
      if (fill) {
        var pct = total > 0 ? Math.max(0, (deadline - Date.now()) / total) : 0;
        if (pct > 1) pct = 1;
        // scaleX, not width. A ~300px bar draining over 5 minutes moves one
        // pixel per second, and `width` snaps to whole device pixels — so it
        // can only ever step once a second however often it is updated.
        // Transforms are composited with sub-pixel precision and interpolate
        // smoothly between pixels.
        fill.style.transform = 'scaleX(' + pct.toFixed(5) + ')';
        fill.style.backgroundColor = mix(from, to, 1 - pct);
      }
      requestAnimationFrame(drain);
    })();
  }

  // Reward state, kept across drawer re-renders so a crossing is detectable.
  // null = not yet known, so an already-qualifying cart does not fire on load.
  var wasEarned = null, wasEarned2 = null;

  /**
   * Repaint several times over ~700ms.
   *
   * The theme re-renders the drawer on its own schedule — quantity steppers and
   * the remove button do not go through this file at all. A single paint can
   * therefore run against half-updated markup, which is how the bar ends up
   * showing 100% next to "$36.01 away": the copy repainted from the new total
   * and the fill was written before the new markup existed. Painting again a
   * few times costs nothing and cannot land early.
   */
  var repaintTimers = [];
  function repaintSoon() {
    repaintTimers.forEach(clearTimeout);
    repaintTimers = [0, 120, 350, 700].map(function (ms) {
      return setTimeout(function () { paintCheckoutTotal(); paintLadder(); }, ms);
    });
  }

  /** Merchant copy goes through innerHTML, so it must be escaped. */
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /** Small radial firework at the milestone. Self-cleaning. */
  function burst(host) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // a ring first — it reads as a celebration even if the eye misses the sparks
    var ring = document.createElement('span');
    ring.className = 'brc__ring';
    host.appendChild(ring);
    setTimeout(function () { ring.remove(); }, 1300);

    var colours = ['#F5C542', '#EE6C4D', '#4EA8DE', '#7BD389', '#F58BB0'];
    for (var i = 0; i < 18; i++) {
      var a = (Math.PI * 2 * i) / 18 + Math.random() * 0.3;
      var d = 34 + Math.random() * 26;
      var sp = document.createElement('span');
      sp.className = 'brc__spark';
      sp.style.background = colours[i % colours.length];
      sp.style.setProperty('--dx', (Math.cos(a) * d).toFixed(1) + 'px');
      sp.style.setProperty('--dy', (Math.sin(a) * d).toFixed(1) + 'px');
      sp.style.animationDelay = (Math.random() * 60).toFixed(0) + 'ms';
      host.appendChild(sp);
      (function (el) { setTimeout(function () { el.remove(); }, 1700); })(sp);
    }
  }

  /**
   * Keep the free-shipping ladder honest without asking the server.
   *
   * Liquid renders it correctly on every drawer refresh, but a missed refresh
   * leaves a stale "Free shipping unlocked" beside a cart that no longer
   * qualifies. Recomputing from the total the drawer is ALREADY showing makes
   * the two impossible to disagree — the same trick that fixed the checkout
   * button, and it introduces no fetch to race.
   */
  function paintLadder() {
    var rail = document.querySelector('[data-cro-ladder]'); if (!rail) return;
    var target = parseInt(rail.getAttribute('data-target'), 10); if (!target) return;
    var shown = readRenderedTotal(); if (!shown) return;
    var digits = shown.replace(/[^\d.,]/g, '').replace(/,/g, '');
    var cents = Math.round(parseFloat(digits) * 100);
    if (!isFinite(cents)) return;

    // Everything derived from the cart is computed BEFORE it is used. These
    // sat below the first use of `ladderMax`, and `var` hoists the declaration
    // without the value — so `pct` was NaN, `width:"NaN%"` was rejected by the
    // browser, and the bar kept whatever Liquid last rendered.
    var remaining  = target - cents;
    var t2         = parseInt(rail.getAttribute('data-target2'), 10) || 0;
    var ladderMax  = parseInt(rail.getAttribute('data-max'), 10) || target;
    var earned     = remaining <= 0;
    var earned2    = t2 > 0 && cents >= t2;
    var pct        = Math.max(0, Math.min(100, cents * 100 / ladderMax));

    var txt = rail.querySelector('.brc__rwtxt');
    if (txt) {
      var label  = rail.getAttribute('data-label')  || 'free shipping';
      var label2 = rail.getAttribute('data-label2') || '';
      var win    = rail.getAttribute('data-win')    || 'Free shipping unlocked!';
      if (remaining > 0) {
        txt.className = 'brc__rwtxt';
        txt.innerHTML = "You're <b>" + money(remaining) + '</b> away from <b>' + esc(label) + '</b>';
      } else if (t2 > 0 && cents < t2) {
        txt.className = 'brc__rwtxt brc__rwtxt--win';
        txt.innerHTML = esc(win) + '<span class="brc__rwnext">'
                      + money(t2 - cents) + ' away from ' + esc(label2) + '</span>';
      } else {
        txt.className = 'brc__rwtxt brc__rwtxt--win';
        txt.textContent = win;
      }
    }
    var fill = rail.querySelector('.brc__fill');
    if (fill) fill.style.width = pct + '%';

    // the face rides the head of the fill and grins wider as it advances
    var face = rail.querySelector('[data-cro-face]');
    if (face) {
      face.style.left = pct + '%';
      face.classList.toggle('is-on', earned);
      var mouth = face.querySelector('[data-cro-mouth]');
      // control point drops from 13 (flat) to 19 (broad smile)
      if (mouth) mouth.setAttribute('d', 'M7.6 14.6 Q12 ' + (13 + pct * 0.06).toFixed(2) + ' 16.4 14.6');
    }

    // Crossing is tracked in a module variable, NOT on the element. The drawer
    // re-renders from Liquid with `is-on` already applied the moment the cart
    // qualifies, so reading the class back could never see a transition — which
    // is exactly why the firework never fired.
    var node  = rail.querySelector('[data-cro-node]');
    var node2 = rail.querySelector('[data-cro-node2]');
    if (node)  node.classList.toggle('is-on', earned);
    if (node2) node2.classList.toggle('is-on', earned2);

    if (wasEarned !== null && earned && !wasEarned && node) burst(node);
    if (wasEarned2 !== null && earned2 && !wasEarned2 && node2) burst(node2);
    wasEarned = earned;
    wasEarned2 = earned2;
  }

  // --- Drawer upsell ---
  // Built with createElement/textContent rather than innerHTML: product titles
  // routinely contain & and " (e.g. "Nail Bracelet (fine) (in silver & gold)"),
  // which string concatenation renders as broken markup.
  var cache = {};
  function upEl(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function upMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function fillUpsell() {
    var box = document.querySelector('[data-cro-upsell]'); if (!box) return;
    var slot = box.querySelector('[data-cro-upsell-slot]'); if (!slot || slot.dataset.filled === '1') return;
    var pid = box.getAttribute('data-first'); if (!pid) return;
    var rows = (box.getAttribute('data-layout') || 'rows') !== 'carousel';
    var max = parseInt(box.getAttribute('data-limit'), 10) || 3;

    function image(p, size) {
      var src = p.featured_image || (p.images && p.images[0]) || '';
      if (!src) return upEl('span', 'cro-up__img');
      var img = upEl('img', 'cro-up__img');
      // the URL already carries a query string, so the sizing param appends
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
      img.alt = ''; img.loading = 'lazy';
      return img;
    }
    function priceLine(v) {
      var wrap = upEl('span', 'cro-up__p');
      wrap.appendChild(upEl('b', null, upMoney(v.price)));
      if (v.compare_at_price && v.compare_at_price > v.price) {
        wrap.appendChild(upEl('s', 'cro-up__was', upMoney(v.compare_at_price)));
        var off = Math.round((1 - v.price / v.compare_at_price) * 100);
        if (off >= 5) wrap.appendChild(upEl('em', 'cro-up__off', off + '% off'));
      }
      return wrap;
    }
    function addBtn(v, title) {
      var b = upEl('button', 'cro-up__add', rows ? '+' : 'Add +');
      b.type = 'button';
      b.setAttribute('data-cro-upsell-add', '');
      b.setAttribute('data-id', v.id);
      b.setAttribute('aria-label', 'Add ' + title + ' to cart');
      return b;
    }

    function render(products) {
      var list = (products || []).filter(function (x) { return x.available; }).slice(0, max);
      if (!list.length) { box.style.display = 'none'; return; }
      slot.dataset.filled = '1';
      slot.textContent = '';
      var track = upEl('div', rows ? 'cro-up__list' : 'cro-up__track');
      list.forEach(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v) return;
        var cell = upEl('div', rows ? 'cro-up__row' : 'cro-up__card');
        cell.appendChild(image(p, rows ? 160 : 300));
        if (rows) {
          var info = upEl('div', 'cro-up__info');
          info.appendChild(upEl('span', 'cro-up__t', p.title));
          info.appendChild(priceLine(v));
          cell.appendChild(info);
        } else {
          cell.appendChild(upEl('span', 'cro-up__t', p.title));
          cell.appendChild(priceLine(v));
        }
        cell.appendChild(addBtn(v, p.title));
        track.appendChild(cell);
      });
      slot.appendChild(track);
    }
    // Manual picks are already in the page as JSON -- no network call at all.
    if (box.getAttribute('data-source') === 'manual') {
      var tag = box.querySelector('[data-cro-upsell-manual]');
      var picked = [];
      if (tag) { try { picked = JSON.parse(tag.textContent || '[]'); } catch (e) { picked = []; } }
      // shape it like the recommendations payload so render() stays one path
      return render(picked.map(function (m) {
        return { title: m.title, available: m.available, featured_image: m.image,
                 variants: [{ id: m.id, price: m.price,
                              compare_at_price: m.compare_at_price || null, available: m.available }] };
      }));
    }
    if (cache[pid]) return render(cache[pid]);
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) { cache[pid] = d.products || []; render(cache[pid]); })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-upsell-add]'); if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.classList.add('is-busy');
    cartCache = null;
    json('/cart/add.js', { id: Number(btn.getAttribute('data-id')), quantity: 1 })
      .then(function (c) { setCartCache(c); return sectionedCart(); })
      .then(refresh)
      .catch(function () { btn.classList.remove('is-busy'); btn.disabled = false; });
  });

  // Fill upsell on drawer open + on load
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble, [href$="/cart"], .header__icon--cart, [data-tabbar-cart]')) setTimeout(function () { fillUpsell(); manageGift(); manageProtection(); startReserve(); paintCheckoutTotal(); paintLadder(); }, 140);
  });
  // --- Discount code ---
  // Shopify has no AJAX endpoint for applying a code to the cart. /discount/CODE
  // is the only supported route, and it redirects — so the drawer state is lost
  // either way. Rather than pretend otherwise, validate the field, then send the
  // browser to /discount/CODE?redirect=/cart, which applies it and lands on a
  // page showing the result.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cro-discount]'); if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="code"]');
    var msg = document.querySelector('[data-cro-discount-msg]');
    var code = (input && input.value || '').trim();
    function say(text, state) {
      if (!msg) return;
      msg.textContent = text;
      msg.setAttribute('data-state', state || '');
      msg.hidden = !text;
    }
    if (!code) { say('Enter a code first.', 'err'); input && input.focus(); return; }
    if (!/^[A-Za-z0-9_\-]{2,64}$/.test(code)) { say('That code contains characters we can’t use.', 'err'); return; }
    say('Applying…', '');
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });

  // Expose for Quick View / other modules to reuse the drawer
  window.BRCart = {
    add: function (id, qty) {
      cartCache = null;
      return json('/cart/add.js', { id: Number(id), quantity: qty || 1 })
        .then(function (c) { setCartCache(c); return sectionedCart(); })
        .then(refresh);
    },
    refresh: refresh, sectionedCart: sectionedCart,
    open: function () { var d = document.querySelector('cart-drawer'); if (d && typeof d.open === 'function') d.open(); }
  };

  /* The theme re-renders the drawer on its own too. Watching the subtree means
     the button follows the cart no matter who changed it. */
  function watchDrawer() {
    var d = document.querySelector('cart-drawer') || document.body;
    if (!d || d.dataset.brWatched === '1') return;
    d.dataset.brWatched = '1';
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; paintCheckoutTotal(); paintLadder(); });
      repaintSoon();
    }).observe(d, { childList: true, subtree: true, characterData: true });
  }

  /* The theme owns the quantity stepper and the remove button, so nothing here
     is notified when they fire. Catching the clicks directly means the ladder
     and the button follow a removal immediately instead of on the next
     unrelated mutation. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quantity__button, cart-remove-button, .cart-remove-button, [name="minus"], [name="plus"]')) {
      repaintSoon();
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('.quantity__input, [name="updates[]"]')) repaintSoon();
  });

  function boot() {
    fillUpsell(); manageGift(); manageProtection(); startReserve();
    paintCheckoutTotal(); paintLadder(); watchDrawer();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

})();

